import client from './client';
import { OverlayAnchor, OverlaySize } from '../types';

export interface BrandingDefaultsConfig {
  anchor: OverlayAnchor;
  size: OverlaySize;
  opacity: number;
}

export interface BrandingDefaultsResponse {
  name: string;
  storagePath: string;
  config: BrandingDefaultsConfig;
}

export const brandingApi = {
  getDefaults: () =>
    client.get<BrandingDefaultsResponse>('/user/branding-defaults').then((r) => r.data),
};
